// extracted by mini-css-extract-plugin
export default {"user_block":"UserInfo_user_block__5Eiln","account_info":"UserInfo_account_info__OfFed","icon":"UserInfo_icon__-hq0j"};